import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Tc } from '../../../../core/_infrastructure/types/common';

@Injectable()
export class DocumentacionCamService {
    private documentacionCamEndPoint = this.baseUrl + 'api/mantenimiento/documentacioncam/';

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    getTipoDocumentacionCam(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.documentacionCamEndPoint + 'tipodocumentacioncam');
    }
}
